import React, { useEffect, useState, useMemo } from "react";

import { OidcProvider } from "redux-oidc";
import { ANONYMOUS_MODE, createManager } from "../authentication/user-manager";

import { Provider } from "react-redux";
import store from "../redux/store";

import DebugPanel from "../components//debug-panel";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import HomePage from "./pages/home-page";
import ReportPage from "./pages/report-page";
import ChangelogPage from "./pages/changelog-page";

import AuthCallback from "../authentication/auth-callback";
import SignoutCallback from "../authentication/signout-callback";

import "./pages.scss";
import CheckAuth from "../authentication/check-auth";
import { Spinner } from "../components//state-indicators";
import ReferencePage from "./pages/reference-page/index.ts";

const development = process.env.NODE_ENV !== "production";

const App = () => {
    // Setup user manager identity server
    const [userManager, setUserManager] = useState(null);
    const [basepath, setBasePath] = useState(null);
    useEffect(() => {
        const prepare = async () => {
            const _basePath = getBasepath();
            setBasePath(_basePath);

            const mng = await createManager(store, _basePath);
            setUserManager(mng);
        };

        prepare();
    }, []); // eslint-disable-line

    const anonymousMode = useMemo(() => {
        return userManager?.mode === ANONYMOUS_MODE;
    }, [userManager]);

    function getBasepath() {
        // Get basepath from HTML
        let _basepath = "";
        const elBase = document.querySelector("base");
        if (elBase?.hasAttribute("href")) {
            const baseValue = elBase.getAttribute("href");
            if (!baseValue) return "";

            try {
                // Если полноценный url (напр. "https://localhost/ktauto/")
                const url = new URL(baseValue);
                _basepath = url.pathname;
            } catch {
                // Если просто pathname задан (напр. "/ktauto/")
                _basepath = baseValue;
            }
            if (_basepath.startsWith("/")) _basepath = _basepath.slice(1);
            if (_basepath.endsWith("/")) _basepath = _basepath.slice(0, -1);
        }
        return _basepath;
    }

    const useCloseAppFile = userManager?.useCloseAppByFile;

    const content = (
        <>
            {development ? <DebugPanel /> : null}
            {
                <Router basename={basepath}>
                    <Routes>
                        <Route path="/print" element={<ReportPage printMode {...{ basepath, anonymousMode }} />} />
                        <Route
                            path="/home"
                            element={
                                <CheckAuth {...{ anonymousMode }}>
                                    <HomePage {...{ basepath, anonymousMode }} />
                                </CheckAuth>
                            }
                        />
                        <Route path="/reference" element={<ReferencePage {...{ anonymousMode, basepath }} />} />
                        <Route
                            path="/authentication/callback"
                            element={
                                <CheckAuth {...{ anonymousMode }}>
                                    <AuthCallback />
                                </CheckAuth>
                            }
                        />
                        <Route
                            path="/authentication/signoutCallback"
                            element={
                                <CheckAuth {...{ anonymousMode }}>
                                    <SignoutCallback />
                                </CheckAuth>
                            }
                        />
                        <Route
                            path="/report"
                            element={
                                <CheckAuth {...{ anonymousMode }}>
                                    <ReportPage {...{ basepath, anonymousMode, useCloseAppFile }} />
                                </CheckAuth>
                            }
                        />
                        <Route
                            path="/changelog"
                            element={
                                <CheckAuth {...{ anonymousMode }}>
                                    <ChangelogPage />
                                </CheckAuth>
                            }
                        />
                        <Route
                            path={"*"}
                            element={
                                <CheckAuth {...{ anonymousMode }}>
                                    <HomePage {...{ basepath, anonymousMode, useCloseAppFile }} />
                                </CheckAuth>
                            }
                        />
                    </Routes>
                </Router>
            }
        </>
    );

    return (
        <Provider store={store}>
            {userManager ? (
                anonymousMode ? (
                    content
                ) : (
                    <OidcProvider userManager={userManager} store={store}>
                        {content}
                    </OidcProvider>
                )
            ) : (
                <Spinner /> // Wait for identity server user manager creation
            )}
        </Provider>
    );
};

export default App;
